import script from "./ButtonClose.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonClose.vue?vue&type=script&setup=true&lang=js"

import "./ButtonClose.vue?vue&type=style&index=0&id=5ed03afa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed03afa"]])

export default __exports__